import { AlertVariant } from 'types/enums';
import { TFunction } from 'i18next';

const getSettingSuccessAlert = (setting: string, t: TFunction) => ({
  variant: AlertVariant.SUCCESS,
  title: t('Setting updated'),
  text: t(`The ${setting} setting has been successfully updated.`),
  cancelButtonText: t('Close')
});

export default getSettingSuccessAlert;
